<template>
  <div>
    <div class="product-list-container" v-if="getShopStatus === true">
      <v-flex xs12 class="topbar-container">
        <SearchPanel/>
        <CategoriesSelector/>
      </v-flex>
      <ProductList/>
    </div>
    <v-layout row wrap v-else class='text-xs-center shop-not-found'>
      <v-flex xs6 offset-xs3>
        <v-card>
          <v-card-title primary-title class="text-xs-center">
            <div class="">{{ $t('shop_not_found') }}</div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import CategoriesSelector from './CategoriesSelector.vue'
import SearchPanel from './SearchPanel.vue'
import ProductList from './ProductList.vue'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProductsList',
  props: [
    'publicToken',
    'shappyCustomToken',
    'appId',
    'channelId',
    'primaryColor',
    'secondaryColor',
    'language'
  ],
  components: {
    CategoriesSelector,
    SearchPanel,
    ProductList
  },
  computed: {
    ...mapGetters([
      'getUserInfo',
      'getParams',
      'getShopStatus'
    ])
  },
  methods: {
    ...mapActions([
      'setParams',
      'getCurrencyAPI',
      'getUserInfoAPI'
    ]),
    initShopCartOmise (language, primaryColor, secondaryColor) {
      let rpcartOmiseContainer = document.getElementById('rp-cart-omise-container')
      let omiseElement = '<rp-omise-response'
      omiseElement += ' order-status="' + this.$route.query.rpshop_order_status + '"'
      omiseElement += ' order-id="' + this.$route.query.rpshop_order_id + '"'

      if (this.$route.query.rpshop_error_code && this.$route.query.rpshop_error_code !== '') {
        omiseElement += ' error-code="' + this.$route.query.rpshop_error_code + '"'
      }

      omiseElement += ' locale="' + language + '"'
      omiseElement += ' primary-main-color="' + primaryColor + '"'
      omiseElement += ' primary-sub-color="' + secondaryColor + '"'
      omiseElement += ' secondary-main-color="' + primaryColor + '"'
      omiseElement += ' secondary-sub-color="' + secondaryColor + '">'
      omiseElement += '</rp-omise-response>'

      rpcartOmiseContainer.innerHTML = omiseElement
    }
  },
  created () {
    if (this.$route.query.rpshop_order_status && this.$route.query.rpshop_order_id && this.getShopStatus === true) {
      this.initShopCartOmise(this.getParams.language,
        this.getParams.primaryColor, this.getParams.secondaryColor)
    }
  }
}
</script>

<style lang="scss" scoped>
.topbar-container {
  width: 100%;
  position: fixed;
  z-index: 2;
}
.shop-not-found {
  height: 100vh;
  align-items: center;
  display: flex;
  .text-xs-center {
    display: block;
    padding: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopCategory/productsList/index.vue